export function formatEuro(priceCents: number): string {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
    priceCents / 100,
  );
}

export function centsToEuroInput(priceCents: number): string {
  return (priceCents / 100).toFixed(2).replace(".", ",");
}

export function eurosToCents(raw: string): number | null {
  const normalized = raw.trim().replace(",", ".");
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) {
    return null;
  }
  return Math.round(Number.parseFloat(normalized) * 100);
}
